export const css = {
	root: '_3flLcXO_',
	clear: 'ZUjAu6Cb',
	player: '_3XZHcRzb',
	playlist: '_2ZHt6bP1',
	playlistTitle: '_13PEEUtm',
	playlistItem: '_3JqOZFUN',
	' _key': 'ascm-theme/ascm/audio/audio'
};

export default css;
